import React from "react";
import Chart from "react-apexcharts";
import {
  FiShoppingCart,
  FiUsers,
  FiBox,
  FiTruck,
  FiCalendar,
  FiChevronDown,
  FiMapPin,
} from "react-icons/fi";
import { BiRupee, BiStore } from "react-icons/bi";
import { BsArrowUpShort } from "react-icons/bs";

/* ------------------------------------------------------------------ */
/*  DATA                                                               */
/* ------------------------------------------------------------------ */
const statCards = [
  {
    label: "Total Orders",
    value: "1,245",
    change: "12%",
    icon: FiShoppingCart,
    main: "#3b82f6",
    from: "#eaf3ff",
    border: "#d6e8ff",
    spark: [8, 14, 11, 18, 13, 20, 24],
  },
  {
    label: "Total Sales (INR)",
    value: "18,56,320",
    change: "18%",
    icon: BiRupee,
    main: "#10b981",
    from: "#e6f9ef",
    border: "#c9f0dc",
    spark: [6, 12, 9, 15, 12, 18, 22],
  },
  {
    label: "Total Customers",
    value: "892",
    change: "10%",
    icon: FiUsers,
    main: "#f43f5e",
    from: "#ffe9ee",
    border: "#ffd3dc",
    spark: [12, 9, 14, 10, 16, 13, 19],
  },
  {
    label: "Active Sellers",
    value: "156",
    change: "8%",
    icon: BiStore,
    main: "#f59e0b",
    from: "#fff4dc",
    border: "#fde5ac",
    spark: [5, 11, 8, 15, 12, 17, 21],
  },
  {
    label: "Total Products",
    value: "3,428",
    change: "15%",
    icon: FiBox,
    main: "#9333ea",
    from: "#f3e8ff",
    border: "#e4cffd",
    spark: [7, 5, 12, 10, 16, 14, 20],
  },
  {
    label: "Shipments",
    value: "987",
    change: "20%",
    icon: FiTruck,
    main: "#0ea5e9",
    from: "#e3f4fe",
    border: "#c8e8fb",
    spark: [10, 15, 11, 16, 13, 18, 23],
  },
];

const orderStatus = [
  { label: "Delivered", count: 682, pct: "54.8%", color: "#10b981" },
  { label: "Processing", count: 248, pct: "19.9%", color: "#3b82f6" },
  { label: "Shipped", count: 186, pct: "15.0%", color: "#f97316" },
  { label: "Pending", count: 78, pct: "6.3%", color: "#facc15" },
  { label: "Cancelled", count: 32, pct: "2.6%", color: "#ef4444" },
  { label: "Returned", count: 19, pct: "1.5%", color: "#8b5cf6" },
];

const topProducts = [
  { id: 1, name: "Handwoven Cotton Saree", cat: "Handloom", sales: 320, rev: "4,80,000", img: "https://images.unsplash.com/photo-1610030469983-98e550d615ef?auto=format&fit=crop&w=80&q=80" },
  { id: 2, name: "Brass Pooja Diya Set", cat: "Home Decor", sales: 210, rev: "2,94,000", img: "https://images.unsplash.com/photo-1610427845722-e42d765fb18a?auto=format&fit=crop&w=80&q=80" },
  { id: 3, name: "Kalamkari Dupatta", cat: "Textiles", sales: 180, rev: "1,98,000", img: "https://images.unsplash.com/photo-1601934988636-f83196f7e4da?auto=format&fit=crop&w=80&q=80" },
  { id: 4, name: "Wooden Wall Art", cat: "Home Decor", sales: 150, rev: "1,50,000", img: "https://images.unsplash.com/photo-1513519245088-0e12902e5a38?auto=format&fit=crop&w=80&q=80" },
  { id: 5, name: "Terracotta Planter Set", cat: "Pottery", sales: 120, rev: "1,08,000", img: "https://images.unsplash.com/photo-1485955900006-10f4d324d411?auto=format&fit=crop&w=80&q=80" },
];

const statusStyles = {
  Delivered: "bg-emerald-100 text-emerald-700",
  Shipped: "bg-blue-100 text-blue-600",
  Processing: "bg-amber-100 text-amber-600",
  Pending: "bg-orange-100 text-orange-600",
};

const recentOrders = [
  { id: "ORD-2026-001245", cust: "Priya Sharma", amt: "2,499", stat: "Delivered", date: "07 Oct 2026" },
  { id: "ORD-2026-001244", cust: "Rahul Mehta", amt: "1,799", stat: "Shipped", date: "07 Oct 2026" },
  { id: "ORD-2026-001243", cust: "Anita Desai", amt: "3,250", stat: "Processing", date: "07 Oct 2026" },
  { id: "ORD-2026-001242", cust: "Vikram Singh", amt: "899", stat: "Pending", date: "06 Oct 2026" },
  { id: "ORD-2026-001241", cust: "Neha Kapoor", amt: "5,499", stat: "Delivered", date: "06 Oct 2026" },
];

const topSellers = [
  { name: "Odisha Handlooms", sales: "4,80,000", orders: 320, img: "https://randomuser.me/api/portraits/women/44.jpg" },
  { name: "Rajasthan Crafts", sales: "3,75,200", orders: 258, img: "https://randomuser.me/api/portraits/men/32.jpg" },
  { name: "Assam Weaves", sales: "2,98,500", orders: 210, img: "https://randomuser.me/api/portraits/women/68.jpg" },
];

const topCategories = [
  { name: "Handloom", prod: 820, sales: "8,50,000", tile: "bg-amber-100 text-amber-600 border-amber-200", letter: "H" },
  { name: "Home Decor", prod: 640, sales: "5,60,000", tile: "bg-rose-100 text-rose-600 border-rose-200", letter: "D" },
  { name: "Textiles", prod: 540, sales: "4,20,000", tile: "bg-purple-100 text-purple-600 border-purple-200", letter: "T" },
  { name: "Pottery", prod: 320, sales: "2,80,000", tile: "bg-orange-100 text-orange-600 border-orange-200", letter: "P" },
];

const regions = [
  { name: "Maharashtra", orders: 320, rev: "4,85,000", color: "#3b82f6" },
  { name: "Delhi", orders: 280, rev: "3,95,000", color: "#0ea5e9" },
  { name: "Karnataka", orders: 210, rev: "2,80,000", color: "#f59e0b" },
  { name: "Tamil Nadu", orders: 180, rev: "2,45,000", color: "#f97316" },
  { name: "Uttar Pradesh", orders: 150, rev: "1,98,000", color: "#10b981" },
];

/* ------------------------------------------------------------------ */
/*  HELPERS                                                            */
/* ------------------------------------------------------------------ */
const cardShadow = "shadow-[0_1px_2px_rgba(16,24,40,0.04),0_8px_24px_-12px_rgba(16,24,40,0.10)]";

/** Smooth sparkline built from an array of numbers */
const Sparkline = ({ data, color, id }) => {
  const w = 100, h = 28, max = Math.max(...data), min = Math.min(...data);
  const pts = data.map((v, i) => [
    (i / (data.length - 1)) * w,
    h - 3 - ((v - min) / (max - min || 1)) * (h - 8),
  ]);
  const line = pts.reduce((acc, [x, y], i, arr) => {
    if (i === 0) return `M${x},${y}`;
    const [px, py] = arr[i - 1];
    const cx = (px + x) / 2;
    return `${acc} C${cx},${py} ${cx},${y} ${x},${y}`;
  }, "");
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-full" preserveAspectRatio="none">
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.25" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={`${line} L${w},${h} L0,${h} Z`} fill={`url(#${id})`} />
      <path d={line} fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
    </svg>
  );
};

const SectionHeader = ({ title, small, right }) => (
  <div className="flex items-center justify-between px-5 pt-5 pb-4">
    <h2 className={`${small ? "text-[15px]" : "text-lg"} font-bold text-slate-800 tracking-tight`}>{title}</h2>
    {right || (
      <button className="text-xs font-semibold text-blue-600 hover:text-blue-700 transition-colors">View All</button>
    )}
  </div>
);

const Dropdown = ({ children }) => (
  <button className="flex items-center gap-2 text-[13px] text-slate-600 bg-white border border-slate-200 px-3 py-1.5 rounded-lg hover:bg-slate-50 transition-colors">
    {children} <FiChevronDown className="text-slate-500" />
  </button>
);

const hideOnError = (e) => {
  e.currentTarget.style.display = "none";
};

const thCls = "px-5 py-3 text-[12px] font-semibold text-slate-600 whitespace-nowrap";
const theadCls = "bg-slate-50/80";

/* ------------------------------------------------------------------ */
/*  CHART OPTIONS                                                      */
/* ------------------------------------------------------------------ */
const salesSeries = [
  { name: "Sales (₹)", data: [95000, 122000, 115000, 165000, 148000, 168000, 195000] },
  { name: "Orders", data: [35000, 42000, 50000, 80000, 70000, 85000, 105000] },
];

const salesOptions = {
  chart: {
    type: "area",
    toolbar: { show: false },
    zoom: { enabled: false },
    fontFamily: "inherit",
    parentHeightOffset: 0,
  },
  colors: ["#10b981", "#3b82f6"],
  stroke: { curve: "smooth", width: 2.5 },
  fill: {
    type: "gradient",
    gradient: { shadeIntensity: 1, opacityFrom: 0.28, opacityTo: 0.02, stops: [0, 95, 100] },
  },
  dataLabels: { enabled: false },
  markers: {
    size: 4.5,
    strokeWidth: 2,
    strokeColors: "#fff",
    hover: { size: 6 },
  },
  legend: {
    show: true,
    position: "top",
    horizontalAlign: "center",
    fontSize: "12px",
    markers: { width: 16, height: 4, radius: 4 },
    itemMargin: { horizontal: 14 },
    labels: { colors: "#475569" },
  },
  grid: {
    borderColor: "#e8edf3",
    strokeDashArray: 0,
    padding: { left: 6, right: 14, top: -8 },
  },
  xaxis: {
    categories: ["01 Oct", "02 Oct", "03 Oct", "04 Oct", "05 Oct", "06 Oct", "07 Oct"],
    axisBorder: { show: false },
    axisTicks: { show: false },
    labels: { style: { colors: "#94a3b8", fontSize: "11px" } },
    tooltip: { enabled: false },
  },
  yaxis: {
    min: 0,
    max: 250000,
    tickAmount: 5,
    labels: {
      style: { colors: "#94a3b8", fontSize: "11px" },
      formatter: (v) => v.toLocaleString("en-US"),
    },
  },
  tooltip: {
    theme: "light",
    y: { formatter: (v, { seriesIndex }) => (seriesIndex === 0 ? `₹ ${v.toLocaleString("en-IN")}` : `${Math.round(v / 100)} orders`) },
  },
};

const donutSeries = orderStatus.map((s) => s.count);
const donutOptions = {
  chart: { type: "donut", fontFamily: "inherit", sparkline: { enabled: false } },
  labels: orderStatus.map((s) => s.label),
  colors: orderStatus.map((s) => s.color),
  legend: { show: false },
  dataLabels: { enabled: false },
  stroke: { width: 2, colors: ["#fff"] },
  states: { hover: { filter: { type: "lighten", value: 0.04 } } },
  plotOptions: {
    pie: {
      startAngle: 0,
      donut: {
        size: "66%",
        labels: {
          show: true,
          name: { show: true, offsetY: 16, fontSize: "12px", color: "#64748b" },
          value: { show: true, offsetY: -14, fontSize: "24px", fontWeight: 700, color: "#1e293b" },
          total: {
            show: true,
            label: "Total Orders",
            fontSize: "12px",
            color: "#64748b",
            formatter: () => "1,245",
          },
        },
      },
    },
  },
  tooltip: { fillSeriesColor: false },
};

/* ------------------------------------------------------------------ */
/*  COMPONENT                                                          */
/* ------------------------------------------------------------------ */
const AdminDashboardHome = () => {
  return (
    <div className="space-y-5 font-sans text-slate-700">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-4">
        <div>
          <h1 className="text-[30px] leading-8 font-bold text-white tracking-tight">Admin Dashboard</h1>
          <p className="text-sm text-slate-500 mt-1.5">
            Welcome back, Admin! Here's what's happening with Bharat Karigari today.
          </p>
        </div>
        <button className={`flex items-center gap-2.5 bg-white border border-slate-200 px-4 py-2.5 rounded-lg text-sm text-slate-700 hover:bg-slate-50 transition-colors ${cardShadow}`}>
          <FiCalendar className="text-slate-600" />
          <span>01 Oct 2026 - 07 Oct 2026</span>
          <FiChevronDown className="text-slate-500" />
        </button>
      </div>

      {/* Stat cards */}
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
        {statCards.map((c, i) => {
          const Icon = c.icon;
          return (
            <div
              key={c.label}
              className="rounded-xl p-4 border transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg"
              style={{
                background: `linear-gradient(135deg, ${c.from} 0%, #ffffff 130%)`,
                borderColor: c.border,
              }}
            >
              <div className="flex items-center gap-3">
                <div
                  className="w-11 h-11 shrink-0 rounded-full flex items-center justify-center text-white"
                  style={{ background: c.main, boxShadow: `0 8px 16px -6px ${c.main}99` }}
                >
                  <Icon size={21} />
                </div>
                <div className="min-w-0">
                  <h3 className="text-[22px] leading-6 font-bold text-white truncate">{c.value}</h3>
                  <p className="text-xs text-slate-500 mt-0.5 truncate">{c.label}</p>
                </div>
              </div>
              <div className="flex items-end justify-between mt-4 gap-2">
                <div>
                  <div className="flex items-center text-xs font-bold" style={{ color: "#16a34a" }}>
                    <BsArrowUpShort size={18} className="-ml-1.5" />
                    <span className="-ml-0.5">{c.change}</span>
                  </div>
                  <span className="text-[11px] text-slate-400">vs last week</span>
                </div>
                <div className="w-[52%] h-8">
                  <Sparkline data={c.spark} color={c.main} id={`spark-${i}`} />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Sales overview + Orders status */}
      <div className="grid grid-cols-1 lg:grid-cols-[1.45fr_1fr] gap-5">
        <div className={`bg-white rounded-xl border border-slate-100 ${cardShadow}`}>
          <SectionHeader title="Sales Overview" right={<Dropdown>Last 7 Days</Dropdown>} />
          <div className="px-3 pb-3">
            <Chart options={salesOptions} series={salesSeries} type="area" height={270} />
          </div>
        </div>

        <div className={`bg-white rounded-xl border border-slate-100 ${cardShadow}`}>
          <SectionHeader title="Orders Status" right={<Dropdown>This Month</Dropdown>} />
          <div className="px-5 pb-5 flex flex-col sm:flex-row lg:flex-col xl:flex-row items-center gap-4">
            <div className="w-[210px] shrink-0">
              <Chart options={donutOptions} series={donutSeries} type="donut" height={210} />
            </div>
            <ul className="w-full space-y-3 text-sm">
              {orderStatus.map((s) => (
                <li key={s.label} className="flex items-center justify-between gap-3">
                  <span className="flex items-center gap-2.5 text-slate-700">
                    <span className="w-2.5 h-2.5 rounded-full" style={{ background: s.color }} />
                    {s.label}
                  </span>
                  <span className="whitespace-nowrap">
                    <b className="font-bold text-white">{s.count}</b>
                    <span className="text-slate-500 ml-1">({s.pct})</span>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Top products + Recent orders */}
      <div className="grid grid-cols-1 xl:grid-cols-[1fr_1.05fr] gap-5">
        <div className={`bg-white rounded-xl border border-slate-100 overflow-hidden ${cardShadow}`}>
          <SectionHeader title="Top Selling Products" />
          <div className="overflow-x-auto px-3 pb-3">
            <table className="w-full text-[13px] text-left">
              <thead className={theadCls}>
                <tr>
                  <th className={`${thCls} rounded-l-md`}>#</th>
                  <th className={thCls}>Product</th>
                  <th className={thCls}>Category</th>
                  <th className={thCls}>Sales</th>
                  <th className={`${thCls} text-right rounded-r-md`}>Revenue (₹)</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {topProducts.map((p) => (
                  <tr key={p.id} className="hover:bg-slate-50/60 transition-colors">
                    <td className="px-5 py-2.5 text-slate-600">{p.id}</td>
                    <td className="px-5 py-2.5">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-lg bg-slate-100 overflow-hidden shrink-0 border border-slate-200">
                          <img src={p.img} alt={p.name} onError={hideOnError} className="w-full h-full object-cover" />
                        </div>
                        <span className="text-slate-800 truncate max-w-[170px]">{p.name}</span>
                      </div>
                    </td>
                    <td className="px-5 py-2.5 text-slate-700">{p.cat}</td>
                    <td className="px-5 py-2.5 text-slate-700">{p.sales}</td>
                    <td className="px-5 py-2.5 text-right text-slate-800">{p.rev}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className={`bg-white rounded-xl border border-slate-100 overflow-hidden ${cardShadow}`}>
          <SectionHeader title="Recent Orders" />
          <div className="overflow-x-auto px-3 pb-3">
            <table className="w-full text-[13px] text-left">
              <thead className={theadCls}>
                <tr>
                  <th className={`${thCls} rounded-l-md`}>Order #</th>
                  <th className={thCls}>Customer</th>
                  <th className={thCls}>Amount (₹)</th>
                  <th className={thCls}>Status</th>
                  <th className={`${thCls} rounded-r-md`}>Date</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {recentOrders.map((o) => (
                  <tr key={o.id} className="hover:bg-slate-50/60 transition-colors">
                    <td className="px-5 py-3.5 text-blue-600 hover:text-blue-700 cursor-pointer whitespace-nowrap">{o.id}</td>
                    <td className="px-5 py-3.5 text-slate-800 whitespace-nowrap">{o.cust}</td>
                    <td className="px-5 py-3.5 text-slate-700">{o.amt}</td>
                    <td className="px-5 py-3.5">
                      <span className={`inline-block px-3 py-1 text-[11.5px] font-medium rounded-full ${statusStyles[o.stat]}`}>
                        {o.stat}
                      </span>
                    </td>
                    <td className="px-5 py-3.5 text-slate-600 whitespace-nowrap">{o.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Bottom three */}
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {/* Sellers */}
        <div className={`bg-white rounded-xl border border-slate-100 overflow-hidden ${cardShadow}`}>
          <SectionHeader title="Top Sellers / Artisans" small />
          <div className="overflow-x-auto px-3 pb-3">
            <table className="w-full text-[13px] text-left">
              <thead className={theadCls}>
                <tr>
                  <th className={`${thCls} rounded-l-md`}>#</th>
                  <th className={thCls}>Seller / Artisan</th>
                  <th className={thCls}>Sales (₹)</th>
                  <th className={`${thCls} rounded-r-md`}>Orders</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {topSellers.map((s, i) => (
                  <tr key={s.name} className="hover:bg-slate-50/60 transition-colors">
                    <td className="px-5 py-3 text-slate-600">{i + 1}</td>
                    <td className="px-5 py-3">
                      <div className="flex items-center gap-3">
                        <div className="w-8 h-8 rounded-full bg-slate-200 overflow-hidden shrink-0 border border-slate-200">
                          <img src={s.img} alt={s.name} onError={hideOnError} className="w-full h-full object-cover" />
                        </div>
                        <span className="text-slate-800 truncate max-w-[130px]">{s.name}</span>
                      </div>
                    </td>
                    <td className="px-5 py-3 text-slate-700">{s.sales}</td>
                    <td className="px-5 py-3 text-slate-700">{s.orders}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Categories */}
        <div className={`bg-white rounded-xl border border-slate-100 overflow-hidden ${cardShadow}`}>
          <SectionHeader title="Top Categories" small />
          <div className="overflow-x-auto px-3 pb-3">
            <table className="w-full text-[13px] text-left">
              <thead className={theadCls}>
                <tr>
                  <th className={`${thCls} rounded-l-md`}>#</th>
                  <th className={thCls}>Category</th>
                  <th className={thCls}>Products</th>
                  <th className={`${thCls} rounded-r-md`}>Sales (₹)</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {topCategories.map((c, i) => (
                  <tr key={c.name} className="hover:bg-slate-50/60 transition-colors">
                    <td className="px-5 py-2.5 text-slate-600">{i + 1}</td>
                    <td className="px-5 py-2.5">
                      <div className="flex items-center gap-3">
                        <div className={`w-8 h-8 rounded-lg border flex items-center justify-center text-xs font-bold shrink-0 ${c.tile}`}>
                          {c.letter}
                        </div>
                        <span className="text-slate-800">{c.name}</span>
                      </div>
                    </td>
                    <td className="px-5 py-2.5 text-slate-700">{c.prod}</td>
                    <td className="px-5 py-2.5 text-slate-700">{c.sales}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Regions */}
        <div className={`bg-white rounded-xl border border-slate-100 overflow-hidden md:col-span-2 xl:col-span-1 ${cardShadow}`}>
          <SectionHeader title="Revenue by Region (India)" small />
          <div className="overflow-x-auto px-3 pb-3">
            <table className="w-full text-[13px] text-left">
              <thead className={theadCls}>
                <tr>
                  <th className={`${thCls} rounded-l-md`}>State</th>
                  <th className={thCls}>Orders</th>
                  <th className={`${thCls} rounded-r-md`}>Revenue (₹)</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {regions.map((r) => (
                  <tr key={r.name} className="hover:bg-slate-50/60 transition-colors">
                    <td className="px-5 py-2.5">
                      <div className="flex items-center gap-2.5 text-slate-800">
                        <FiMapPin size={16} style={{ color: r.color }} fill={r.color} fillOpacity={0.25} />
                        {r.name}
                      </div>
                    </td>
                    <td className="px-5 py-2.5 text-slate-700">{r.orders}</td>
                    <td className="px-5 py-2.5 text-slate-700">{r.rev}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboardHome;